/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TaskWorkflowItemStatus } from './TaskWorkflowItemStatus';
import {
    TaskWorkflowItemStatusFromJSON,
    TaskWorkflowItemStatusFromJSONTyped,
    TaskWorkflowItemStatusToJSON,
    TaskWorkflowItemStatusToJSONTyped,
} from './TaskWorkflowItemStatus';

/**
 * 
 * @export
 * @interface UpdateLeadTaskWorkflowItemRequest
 */
export interface UpdateLeadTaskWorkflowItemRequest {
    /**
     * 
     */
    status?: TaskWorkflowItemStatus;
    /**
     * Null unassigns the item.
     */
    assignee_user_id?: string | null;
}

/**
 * Check if a given object implements the UpdateLeadTaskWorkflowItemRequest interface.
 */
export function instanceOfUpdateLeadTaskWorkflowItemRequest(value: object): value is UpdateLeadTaskWorkflowItemRequest {
    return true;
}

export function UpdateLeadTaskWorkflowItemRequestFromJSON(json: any): UpdateLeadTaskWorkflowItemRequest {
    return UpdateLeadTaskWorkflowItemRequestFromJSONTyped(json, false);
}

export function UpdateLeadTaskWorkflowItemRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLeadTaskWorkflowItemRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'] == null ? undefined : TaskWorkflowItemStatusFromJSON(json['status']),
        'assignee_user_id': json['assignee_user_id'] === undefined ? undefined : json['assignee_user_id'] === null ? null : json['assignee_user_id'],
    };
}

export function UpdateLeadTaskWorkflowItemRequestToJSON(json: any): UpdateLeadTaskWorkflowItemRequest {
    return UpdateLeadTaskWorkflowItemRequestToJSONTyped(json, false);
}

export function UpdateLeadTaskWorkflowItemRequestToJSONTyped(value?: UpdateLeadTaskWorkflowItemRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': TaskWorkflowItemStatusToJSON(value['status']),
        'assignee_user_id': value['assignee_user_id'],
    };
}

